<template>
	<section class="thank_order no_banner_page" :class="returnClass">
		<div class="login_box thank_or_box">
			<div class="corner-top"></div>
			<div class="ok-update">
				<OK />
			</div>
			<h2 class="title center">{{ title }}</h2>
			<div class="title ready_title">{{ text }}</div>
			<div class="small_strip"></div>
			<div class="text">
				סיכום ההזמנה יגיע אליך ממש עוד רגע למייל
				<br />
				{{ email }}
			</div>
			<div class="thank_items clearfix">
				<div class="right thank_item">
					<div class="thank_item_icon">
						<QCHAT />
					</div>
					<div class="thank_item_tx">
						יש לך שאלה,
						<br />בקשה או הערה?
					</div>
					<div class="bt_border ease">
						<a-div :href="options.pages.service.replace(wpData.home_url, '')" :new-window="false"
							>אנחנו פה</a-div
						>
					</div>
				</div>
				<div class="right thank_item">
					<div class="thank_item_icon">
						<PEN />
					</div>
					<div class="thank_item_tx">
						שכחת משהו?
						<br />זה לא מאוחר מדי!
					</div>
					<div class="bt_border ease">
						<router-link v-if="!isPermOrder" :to="{ name: 'history' }">לעריכת הזמנה</router-link>
						<router-link
							v-else
							:to="{
								path: '/my-account/permenant',
								params: { state: 'order' }
							}"
						>
							לעריכת הזמנה קבועה</router-link
						>
					</div>
				</div>
				<div class="right thank_item">
					<div class="thank_item_icon">
						<ADDBOOK2 />
					</div>
					<div class="thank_item_tx">
						רוצה להפוך את
						<br />ההזמנה שלך לקבועה?
					</div>
					<div class="bt_border ease">
						<router-link :to="{ name: 'permenent' }">לפרטים נוספים</router-link>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	/** SVG import  */
	import OK from "../assets/img/ok.svg";
	import ADDBOOK2 from "../assets/img/ic-circle-restart.svg";
	import PEN from "../assets/img/pen.svg";
	import QCHAT from "../assets/img/question-chat.svg";
	export default {
		data() {
			return {
				assets: wpData.assets_url,
				wpData: wpData,
				options: wpData.globalOptions,
				isPermOrder: typeof this.$store.state.permenantOrderEdit == "object" ? true : false,
				email: "",
				templates: {},
				template_num: Math.ceil(Math.random() * 4),
				classes: {
					bg1: wpData.assets_url + "/layout/thank_you_1.png",
					bg2: wpData.assets_url + "/layout/thank_you_2.png",
					bg3: wpData.assets_url + "/layout/thank_you_3.png",
					bg4: wpData.assets_url + "/layout/thank_you_4.png"
				}
			};
		},
		computed: {
			returnClass() {
				return "bg" + this.template_num;
			},
			title() {
				switch (this.template_num) {
					case 1:
						return "כיף של הזמנה";
						break;
					case 2:
						return "יש לך טעם נהדר!";
						break;
					case 3:
						return "שיהיה בתיאבון!";
						break;
					case 4:
						return "ההזמנה שלך התקבלה!";
						break;
				}
			},
			text() {
				switch (this.template_num) {
					case 1:
						return "המקרר מוכן? המזווה ערוך? אנחנו בדרך!";
						break;
					case 2:
						return "ההזמנה התקבלה וממש בקרוב יגיעו אליך כל הדברים הטובים שהזמנת";
						break;
					case 3:
						return "בקרוב נתחיל ללקט עבורך את חומרי הגלם הכי טריים בשוק";
						break;
					case 4:
						return "אז מה מבשלים היום?";
						break;
				}
			}
		},
		mounted() {
			this.email = this.$store.getters.userCheckoutInfo.email;
			if (wpData.last_order) {
				if (wpData.last_order.is_permenant) {
					this.isPermOrder = true;
				}
			}

			this.$store.commit("initOrderAs");
			this.$store.commit("clearCart");
			this.$store.commit("setHasOrderEdit", true);

			localStorage.removeItem("formFields");
			this.$store.commit("clearFormFields");
		},
		created() {
			this.$store.state.showCartRecoveredNotice = false;
		},
		components: {
			OK,
			ADDBOOK2,
			PEN,
			QCHAT
		}
	};
</script>
